module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-label pl-1 pt-2"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "colour-frame"
  }, [_c('div', {
    staticClass: "clickable colour-item elevation-1 transparent-checkers",
    style: (_vm.colourItemStyle(null)),
    attrs: {
      "title": "Transparent"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input', null)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.colours), function(colour) {
    return _c('div', {
      key: colour,
      staticClass: "clickable colour-item elevation-1",
      style: (_vm.colourItemStyle(colour)),
      on: {
        "click": function($event) {
          return _vm.$emit('input', colour)
        }
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b250d18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ColourBar.vue
// module id = 2510
// module chunks = 1